import request from '@/utils/httpClient'

import { CostModel } from '@/model/Index'

export const defaultCostModel: CostModel = {
  id: 0,
  name: '',
  mark: ''
}

// 批量删除
export function deleteCostById(id: number) {
  return request({
    url: `costClass/${id}`,
    method: 'delete'
  })
}

// 获取详情
export function getCostDetailByCostId(id: number) {
  return request({
    url: `costClass/${id}`,
    method: 'get'
  })
}

// 获取列表
export function getCostList(params?: object) {
  return request({
    url: 'costClass/page',
    method: 'get',
    params
  })
}

// 获取下拉数据
export function getCostDropdown(params?: object) {
  return request({
    url: 'costClass/dropdown',
    method: 'get',
    params
  })
}
